import { useMemo } from 'react';
import { createDynamicEntitiesApi } from '../api/DynamicEntitiesApi';
import type { DynamicEntitiesApiClient } from '../api/DynamicEntitiesApi';
import { useDynamicEntitiesContext } from '../DynamicEntitiesProvider';

/**
 * Cliente EAV ya cableado con el `baseUrl` y el transporte del provider.
 *
 * Es el único punto por el que deberían pasar los componentes: evita que alguien
 * vuelva a construir una petición sin las cabeceras del anfitrión.
 */
export const useDynamicEntitiesApi = (): DynamicEntitiesApiClient => {
    const { baseUrl, fetcher } = useDynamicEntitiesContext();
    return useMemo(() => createDynamicEntitiesApi({ baseUrl, fetcher }), [baseUrl, fetcher]);
};
